import { useContext } from "react";

import { HeaderIds } from "src/helpers/uiConstants";
import StudyAreaMap from "./StudyAreaMap";
import {
  TypographyH1,
  TypographyH2,
  TypographyH3,
  TypographyP,
} from "./Typography";
import DottedLine from "./ui/DottedLine";
import mLogo from "./ui/images/muniM.png";
import SocialMediaLinksRow from "./ui/SocialMediaLinksRow";
import PageHeaderList from "./PageHeaderList";
import LazyScroll from "./ui/LazyScroll";
import { isMobile } from "src/helpers/mapConstants";
import { LanguageContext } from "./languageContext";
import { LanguagePicker } from "./ui/LanguagePicker";

export default function Introduction() {
  const { translate } = useContext(LanguageContext);
  return (
    <>
      <div className="space-y-4">
        <div className="mx-[-20px] flex justify-between flex-col relative bg-primary md:rounded-b-3xl p-4 md:p-10 md:min-h-[400px]">
          <div className="flex flex-col gap-4 hidden md:flex">
            <SocialMediaLinksRow color="white" />
          </div>
          <TypographyH1
            className="text-primary-foreground md:text-5xl max-w-[500px] md:leading-[60px]"
            textId="title"
          />
          <img
            src={mLogo}
            alt="SFMTA M logo"
            className="hidden md:block absolute bottom-[-20px] right-[-20px] w-[383px]"
          />
        </div>
        <div className="flex justify-between">
          <SocialMediaLinksRow className="md:hidden mr-4" />
          <a
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
            href="https://sfmta.com/ValenciaBikeway"
          >
            SFMTA.com/ValenciaBikeway
          </a>
        </div>
      </div>
      <LanguagePicker />
      <div className="max-w-[300px] xl:hidden">
        <TypographyH3 className="mb-2" textId="pageHighlights" />
        <PageHeaderList />
      </div>
      <div className="hidden xl:flex fixed top-20 xl:left-5 2xl:left-10 space-x-2 2xl:space-x-4">
        <DottedLine />
        <PageHeaderList />
      </div>
      <div className="flex space-x-4">
        <DottedLine />
        <div>
          <TypographyH2 id={HeaderIds.aboutHeader} textId="aboutThisStudy" />
          <TypographyP textId="aboutThisStudyDescription" />
          <TypographyP textId="aboutThisStudyDescription2" />
        </div>
      </div>
      <div className="space-y-4">
        <TypographyP className="text-lg font-bold" textId="studyAreaHeader" />
        <LazyScroll height={isMobile ? "764px" : "555px"}>
          <StudyAreaMap />
        </LazyScroll>
        <TypographyP textId="studyAreaDescription" />
        <TypographyP textId="studyAreaDescription2" />
        <p>
          {translate("studyAreaDescription3")}{" "}
          <a
            className="underline"
            href="https://www.sfmta.com/media/34456/download?inline"
            rel="noopener noreferrer"
            target="_blank"
          >
            {translate("longTermConcepts")}
          </a>
          {translate("studyAreaDescription4")}
        </p>
      </div>
    </>
  );
}
